import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import useBuilderConstructorGridInputs from '../hooks/useBuilderConstructorGridInputs';

import DiscoveryGuideFilterPills from './DiscoveryGuide/DiscoveryGuideFilterPills';
import MobileGridFilters from './MobileGridFilters/MobileGridFilters';
import MobileGridSortDropdown from './MobileGridSortDropdown';

const HeaderWrapper = styled.div``;

const Title = styled.h1`
  font-weight: 700;
  font-size: 24px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  ${({ theme }) => theme.mobileGridHeaderStyle}
`;

const ControlsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
`;

const MobileGridFiltersWrapper = styled.div`
  margin-left: auto;
`;

const MobileGridHeader = ({ isFilterDrawerOpen, setIsFilterDrawerOpen }) => {
  const { gridHeader } = useBuilderConstructorGridInputs();

  return (
    <HeaderWrapper>
      <Title>{gridHeader}</Title>
      <DiscoveryGuideFilterPills />
      <ControlsWrapper>
        <MobileGridSortDropdown />
        <MobileGridFiltersWrapper>
          <MobileGridFilters
            isFilterDrawerOpen={isFilterDrawerOpen}
            setIsFilterDrawerOpen={setIsFilterDrawerOpen}
          />
        </MobileGridFiltersWrapper>
      </ControlsWrapper>
    </HeaderWrapper>
  );
};

MobileGridHeader.propTypes = {
  isFilterDrawerOpen: PropTypes.bool.isRequired,
  setIsFilterDrawerOpen: PropTypes.func.isRequired,
};

export default MobileGridHeader;
